export default "__VITE_ASSET__DV9CPK0a__"